import LinkButton from "components/LinkButton";
import { useEffect, useState } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

const LogsFilters = ({ updateFilters, filters, resetFilters, displayAppIdFilter }) => {
  const [localFilters, setLocalFilters] = useState({});

  useEffect(() => {
    setLocalFilters({ ...filters });
  }, [filters]);

  const handleChange = (e) => {
    setLocalFilters({
      ...localFilters,
      [e.target.name]: e.target.value,
    });
  };

  const search = () => {
    updateFilters(localFilters);
  };

  return (
    <div id="filtersContainer">
      <div>
        <label>From</label>
        <Datetime
          value={localFilters.from}
          onChange={(val) => setLocalFilters({ ...localFilters, from: val })}
          updateOnView={false}
          dateFormat="DD/MM/yyyy"
          initialViewMode="days"
        />
      </div>

      <div>
        <label>To</label>
        <Datetime
          value={localFilters.to}
          onChange={(val) => setLocalFilters({ ...localFilters, to: val })}
          updateOnView={false}
          dateFormat="DD/MM/yyyy"
          initialViewMode="days"
        />
      </div>

      <div>
        <label>Correlation Id</label>
        <input
          className="ampFormControl"
          name="correlationId"
          onChange={handleChange}
          type="text"
          value={localFilters.correlationId ?? ""}></input>
      </div>

      <div>
        <label>Log Level</label>
        <select className="ampFormSelect" name="logLevel" onChange={handleChange} value={localFilters.logLevel ?? ""}>
          <option value="">All</option>
          <option>Information</option>
          <option value={"BusinessError"}>Business Error</option>
          <option value={"SystemError"}>System Error</option>
        </select>
      </div>

      <div>
        <label>Log Message</label>
        <select className="ampFormSelect" name="logMessage" onChange={handleChange} value={localFilters.logMessage ?? ""}>
          <option value="">All</option>
          <optgroup label="Transaction Stages">
            <option>Pin Session Started</option>
            <option>Configuration Requested</option>
            <option>Pin Block Generated</option>
            <option>User Cancelled Pin Entry</option>
          </optgroup>
          <optgroup label="Information">
            <option>Device Details</option>
          </optgroup>
          <optgroup label="Errors">
            <option>Pin Session Expired</option>
            <option>Device failed attestation</option>
          </optgroup>
        </select>
      </div>

      <div>
        <label>Platform</label>
        <select className="ampFormSelect" name="platform" onChange={handleChange} value={localFilters.platform ?? ""}>
          <option value="">All</option>
          <option value="android">Android</option>
          <option value="ios">iOS</option>
        </select>
      </div>

      {displayAppIdFilter && (
        <div>
          <label>Application Id</label>
          <input
            className="ampFormControl"
            name="applicationId"
            onChange={handleChange}
            type="text"
            value={localFilters.applicationId ?? ""}></input>
        </div>
      )}
      
      <div>
        <label>PAN Start</label>
        <input
          className="ampFormControl"
          name="panFirstDigits"
          onChange={handleChange}
          type="text"
          value={localFilters.panFirstDigits ?? ""}></input>
      </div>

      <div>
        <label>PAN End</label>
        <input
          className="ampFormControl"
          name="panLastDigits"
          onChange={handleChange}
          type="text"
          value={localFilters.panLastDigits ?? ""}></input>
      </div>

      <div id="searchButtonDiv">
        <LinkButton type="blue" onClick={search}>
          Search Logs
        </LinkButton>
        <LinkButton type="grey" onClick={resetFilters}>
          Reset Filters
        </LinkButton>
      </div>
    </div>
  );
};

export default LogsFilters;
